import { gtm } from 'root/utils/tracking/googleTagManagerDeprecated';
import config from 'root/main/components/navigation/navigation_config';
import { CookieMonster } from 'root/utils/cookies/cookieMonster';
import btfNavBar from 'root/main/components/navigation/btf/keyboardNavigation';
import {
    openSubMenu,
    closeSubMenu,
} from 'root/main/components/navigation/btf/toggleSubMenu';
import { GoogleTagManager } from 'root/utils/tracking/GA4/googleTagManager';
import navTracking from 'root/utils/tracking/GA4/navigation/navTracking';

export default function NavigationDesktop(els) {
    const cm = new CookieMonster();
    const bodyEl = document.body;
    const verticalSlug = bodyEl.dataset.verticalSlug;
    const navs = els;
    const btCookieName = 'ls_vertical_bt';
    const navHeader = document.querySelector('header.main-site-header-btf');
    const btCookieValue = cm.getCookie(btCookieName);
    /*
     * The local storage BT contains the value of the precedent ls_vertical_bt cookie
     * Ex: if you went from the Apparel page to Bikes, the btLocalStorageValue will be "apparel"
     * and the new ls_vertical_bt cookie value will be "bikes". Now, if you go to Electronics
     * the btLocalStorageValue will be "bikes", the ls_vertical_bt will be "electronics" and so on.
     * */

    const btLocalStorageValue = navigator.cookieEnabled
        ? window.localStorage?.getItem(
              'btf.businessType'
          ) /* we are checking for local storage in case an Android phone loaded the desktop site */
        : null;

    const isCookieDifferentThanLocalStorage =
        btCookieValue && btCookieValue !== btLocalStorageValue;

    if (verticalSlug) {
        /* Send business type cookie setting event when
           the ls_vertical_bt cookie is undefined/null (so is about to get set),
           OR the local storage value is different than the ls_vertical_bt value */
        if (!btCookieValue || isCookieDifferentThanLocalStorage) {
            gtm.businessTypeCookieSet(verticalSlug).sendEvent('business-type');
        }
    }

    if (navs.length > 0) {
        navs.forEach(nav => {
            nav.addEventListener('click', e => {
                if (nav.classList.contains('navigation-btf-desktop--main')) {
                    if (e.target.hasAttribute(config.navigation_link_attribute)) {
                        gtm.menu(e.target).sendEvent('click');

                        const GTMObject = navTracking(e.target);
                        GTMObject && GoogleTagManager.sendEvent(GTMObject);
                    }
                }
                if (nav.classList.contains('navigation-btf-desktop--secondary')) {
                    if (e.target.hasAttribute(config.navigation_link_attribute)) {
                        gtm.secondaryMenu(e.target).sendEvent('click');
                        const GTMObject = navTracking(e.target);
                        GTMObject && GoogleTagManager.sendEvent(GTMObject);
                    }
                }
            });
            if (nav.classList.contains('navigation-btf-desktop--secondary')) {
                /* Setting the cookie and populating the nav values is being handled by a script inserted at the end of the
                 * html/wp-content/themes/ls/views/Section/navigation/btf/layout/desktop_secondary.html.twig
                 * slugMatch: rather then calling the btfNavSecondaryLexic global variable we set a data attribute on the
                 * header container of the nav and we check its value here
                 *  */
                const slugMatch = navHeader.dataset.slugMatch;
                if (slugMatch) {
                    /*@todo
                     *remove repetition and use only one common selector for the "clear cookie" links */
                    const secondaryNavClearButtons = nav.querySelectorAll(
                        '[data-secondary-nav-clear-bt]'
                    );
                    const btfNavClearBtCookieEls = document.querySelectorAll(
                        '[data-btf-nav-clear-cookie]'
                    );
                    if (secondaryNavClearButtons) {
                        secondaryNavClearButtons.forEach(secondaryNavClearButton => {
                            secondaryNavClearButton.addEventListener('click', () => {
                                cm.unsetCookie(btCookieName);
                                navigator.cookieEnabled &&
                                    window.localStorage?.removeItem('btf.businessType');
                            });
                        });
                    }
                    if (btfNavClearBtCookieEls) {
                        btfNavClearBtCookieEls.forEach(btfNavClearBtCookieEl => {
                            btfNavClearBtCookieEl.addEventListener('click', () => {
                                cm.unsetCookie(btCookieName);
                                navigator.cookieEnabled &&
                                    window.localStorage?.removeItem('btf.businessType');
                            });
                        });
                    }
                } else {
                    cm.unsetCookie(btCookieName);
                    navigator.cookieEnabled &&
                        window.localStorage?.removeItem('btf.businessType');
                }
            }

            const navParentSelector = '[data-navigation-level="parent"]';
            const navParentsWithChildren = Array.from(
                nav.querySelectorAll(navParentSelector)
            ).filter(parentElement => {
                return parentElement.querySelector('ul') != null;
            });

            navParentsWithChildren.forEach(parentElement => {
                if (parentElement.children.length > 0) {
                    parentElement.addEventListener('mouseenter', () => {
                        openSubMenu(parentElement);
                    });
                    parentElement.addEventListener('mouseleave', () => {
                        closeSubMenu(parentElement);
                    });
                }
            });
        });
        btfNavBar(navs);
    }
}
